import { Outlet } from "react-router-dom";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import FinishCard from "../components/thirdsideCard/FinishCard";

const SimpleLayout = () => (
  <div className="simple-layout">
    <ErrorBoundary>
      <SeoLoader />
      <Outlet />
      <FinishCard />
    </ErrorBoundary>
  </div>
);

export default SimpleLayout;
